module.exports = __webpack_public_path__ + "static/media/Home Page_website-28.b98e4cc2.png";